module.exports = __webpack_public_path__ + "static/img/KEX.518e084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salepage/integration/KEX.png
// module id = LW5S
// module chunks = 134